<template>
    
</template>

<script>
    import PreviewElement from "./PreviewElement";
    import ContextWrapperElement from "../../components/pagesbuilder/elements/ContextWrapperElement";

    export default {
        name: "PreviewContextWrapperElement",
        mixins: [
            PreviewElement,
            ContextWrapperElement
        ]
    }
</script>

